import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import SearchBar from "../../components/SearchBar";

import TableComponent from "../../components/TableComponent";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import {
  useIndividualApplicationsUserIdMutation,
  usePartnerApplicationsByUserIdMutation,
} from "../../service/users";
import useAuth from "../../hooks/useAuth";
import { ApplicationList } from "../../types/User";
import { CommonBody, PaymentPlanType, Permission } from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import {
  useLazyDeleteApplicationQuery,
  useUpdateApplicationMutation,
} from "../../service/applications";
import { useGetAllPaymentPlanMutation } from "../../service/paymentPlan";
import {
  APPLICATION_STATUS,
  PAYMENT_STATUS,
  SHOW_APPLICATION_STATUS,
  SHOW_USER_ROLES,
  USER_ROLES,
  USER_TYPE_SLUGS,
  VISA_TYPE_NAMES,
  VISA_TYPES_SLUGS,
} from "../../utils/enums";
import { PriceFormatter } from "../../utils/commoFunctions";
import Chip from "../../components/Chip";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { ApplicationApprovalModal } from "../../Modals/applicationApprovalModal";
import { isValidInput } from "../../utils/validations";

type props = {
  id: string | undefined;
  type: string | null | undefined;
};
export const Applicants = ({ id, type }: props) => {
  const userData = useAuth();
  const navigate = useNavigate();
  const [rejectionReason, setRejectionReson] = useState("");

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    row: ApplicationList
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(row?.id);
    setSelectedRow(row);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
    setSelectedRow(null);
  };
  const applicationStatusData = [
    {
      id: APPLICATION_STATUS.CONSULTATION_ADDED,
      label: SHOW_APPLICATION_STATUS[1],
    },
    {
      id: APPLICATION_STATUS.CONNECT_WITH_VISA_COUNSELLOR,
      label: SHOW_APPLICATION_STATUS[2],
    },
    {
      id: APPLICATION_STATUS.DOCUMENT_VERIFIED,
      label: SHOW_APPLICATION_STATUS[3],
    },
    {
      id: APPLICATION_STATUS.ASSESSMENT,
      label: SHOW_APPLICATION_STATUS[4],
    },
    {
      id: APPLICATION_STATUS.CONTRACT_AND_INITIAL_PAYMENT,
      label: SHOW_APPLICATION_STATUS[5],
    },
    {
      id: APPLICATION_STATUS.CHECKLIST_COMPLETION,
      label: SHOW_APPLICATION_STATUS[6],
    },
    {
      id: APPLICATION_STATUS.FILE_PREPARATION,
      label: SHOW_APPLICATION_STATUS[7],
    },
    {
      id: APPLICATION_STATUS.SCHEDULE_APPOINTMENT,
      label: SHOW_APPLICATION_STATUS[8],
    },
    {
      id: APPLICATION_STATUS.LODGEMENT,
      label: SHOW_APPLICATION_STATUS[9],
    },
    {
      id: APPLICATION_STATUS.REGISTER_IN_EMBASSY,
      label: SHOW_APPLICATION_STATUS[10],
    },
  ];

  const [hidePermission, setHidePermission] = useState<Permission>();
  const [searchTerm, setSearchTerm] = useState("");
  const [paymentPlansList, setPaymentPlansList] = useState<PaymentPlanType[]>(
    []
  );
  const [rows, setRows] = useState<ApplicationList[]>([]);

  const [applicationStatuses, setApplicationStatuses] = useState<{
    [key: number]: string;
  }>({});

  const [paymentPlan, setPaymentPlan] = useState<string>("default");
  const [openApprovalModal, setOpenApprovalModal] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState("default");
  const [selectedRow, setSelectedRow] = useState<ApplicationList | null>(null);

  const handleApplicationStatus =
    (row: ApplicationList) => async (event: SelectChangeEvent) => {
      const rowId = row?.id;
      const selectedStatus = event.target.value;
      if (
        Number(selectedStatus) ===
          APPLICATION_STATUS?.CONTRACT_AND_INITIAL_PAYMENT &&
        row?.payment_status !== PAYMENT_STATUS.FIRST_FULL_PAYMENT
      ) {
        errorToast(
          "The status cannot be changed as first payment isn't received yet "
        );
        return;
      }
      if (
        Number(selectedStatus) === APPLICATION_STATUS?.CHECKLIST_COMPLETION &&
        row?.payment_status !== PAYMENT_STATUS.SECOND_PAYMENT
      ) {
        errorToast(
          "The status cannot be changed as second payment isn't received yet "
        );
        return;
      }
      // if (
      //   Number(selectedStatus) === APPLICATION_STATUS?.REGISTER_IN_EMBASSY &&
      //   row?.payment_status !== PAYMENT_STATUS.THIRD_PAYMENT
      // ) {
      //   errorToast(
      //     "The status cannot be changed as third payment isn't received yet "
      //   );
      //   return;
      // }
      setApplicationStatuses((prevStatuses) => ({
        ...prevStatuses,
        [rowId]: event.target.value,
      }));
      try {
        const body = {
          application_status: selectedStatus,
        };

        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await updateApplication({
          body: encryptedBody,
          id: rowId,
        }).unwrap();
        setLoading(false);

        if (response?.status === 200) {
          successToast("Application status changed successfully");
          getApplicationsList();
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        setLoading(false);
      }
    };

  const handlePaymentPlan = (event: SelectChangeEvent) => {
    setPaymentPlan(event.target.value);
  };

  const handleApprovalStatus = (event: SelectChangeEvent) => {
    setApplicationStatus(event.target.value as string);
  };

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);

  const [deleteApplication] = useLazyDeleteApplicationQuery();
  const [getPaymentPlans] = useGetAllPaymentPlanMutation();
  const [updateApplication] = useUpdateApplicationMutation();
  const [individualApplications] = useIndividualApplicationsUserIdMutation();
  const [partnerApplications] = usePartnerApplicationsByUserIdMutation();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleDeleteApplication = async () => {
    setLoading(true);
    try {
      const response = await deleteApplication({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast("Deleted successfully");
        getApplicationsList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const getApplicationsList = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      let response;
      if (type === USER_TYPE_SLUGS.INDIVIDUAL) {
        response = await individualApplications({
          body: encryptedBody,
          id: Number(id),
        }).unwrap();
      } else {
        response = await partnerApplications({
          body: encryptedBody,
          id: Number(id),
        }).unwrap();
      }

      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const getAllPaymentPlans = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 50,
        search: debouncedSearchTerm.trim(),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await getPaymentPlans(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setPaymentPlansList(response?.data?.response_object || []);
      } else {
        setPaymentPlansList([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleApproveReject = async () => {
    if (applicationStatus === "default") {
      errorToast("Please select approve or reject option");
      return;
    }
    if (applicationStatus === "APPROVE" && paymentPlan === "default") {
      errorToast("Please select a payment plan first");
      return;
    }
    if (applicationStatus !== "APPROVE" && rejectionReason === "") {
      errorToast("Please enter the rejection reason");
      return;
    }

    try {
      const body = {
        ...(applicationStatus === "APPROVE"
          ? { is_verified: true }
          : { is_rejected: true }),
        ...(applicationStatus === "APPROVE"
          ? { payment_plan: paymentPlan }
          : { reject_reason: rejectionReason }),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateApplication({
        body: encryptedBody,
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setOpenApprovalModal(false);
        getApplicationsList();
        setPaymentPlan("default");
        setApplicationStatus("default");
        setRejectionReson("");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllPaymentPlans();
  }, []);

  useEffect(() => {
    getApplicationsList();
  }, [debouncedSearchTerm, page]);

  const checkPermission = () => {
    const permission = userData?.role_permission;
    if (permission?.length) {
      const foundPermission = permission?.find(
        (ele: Permission) => ele?.module === "Manage Applications"
      );

      if (foundPermission) {
        setHidePermission(foundPermission);
      } else {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    if (userData?.user_role_type === USER_ROLES.SUBADMIN) {
      checkPermission();
    }
  }, [userData]);

  useEffect(() => {
    if (typeof hidePermission !== "undefined") {
      if (!hidePermission?.can_view) {
        navigate("/permission-denied", { replace: true });
      }
    }
  }, [hidePermission, userData]);

  useEffect(() => {
    if (rows?.length) {
      const initialStatuses: { [key: number]: string } = {};
      rows.forEach((row) => {
        initialStatuses[row?.id] =
          row?.application_status?.toString() || "default"; // Ensure it's a string
      });
      setApplicationStatuses(initialStatuses);
    }
  }, [rows]);

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.5,
      minWidth: 150,
      field: "applicationId",
      headerName: "Id",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.apk_id || "-"}</p>
          </div>
        );
      },
    },
    ...(type === USER_TYPE_SLUGS.INDIVIDUAL
      ? [
          {
            flex: 0.8,
            minWidth: 300,
            field: "applierDetails",
            headerName: "Applier Details",
            editable: false,
            sortable: false,

            renderCell: ({ row }: GridRenderCellParams<any>) => {
              return (
                <div className="user_block">
                  <figure>
                    <img
                      src={
                        row?.applier?.applier_profile_picture?.media_url ||
                        "/static/images/user_placeholder.png"
                      }
                      alt=""
                    />
                  </figure>
                  <p>
                    <b>
                      {row?.applier?.applier_name || "-"} (
                      {SHOW_USER_ROLES[row?.applier?.applier_role]})
                    </b>{" "}
                    {row?.applier?.applier_country_code}{" "}
                    {row?.applier?.applier_phone_no || "-"}
                    <br />
                    {row?.applier?.applier_email || "-"}
                  </p>
                </div>
              );
            },
          },
        ]
      : [
          {
            flex: 0.8,
            minWidth: 300,
            field: "name",
            headerName: "Applicant Details",
            editable: false,
            sortable: false,

            renderCell: ({ row }: GridRenderCellParams<any>) => {
              return (
                <div className="user_block">
                  <figure>
                    <img
                      src={
                        row?.profile_picture?.media_url ||
                        "/static/images/user_placeholder.png"
                      }
                      alt=""
                    />
                  </figure>
                  <p>
                    <b>
                      {row?.first_name || "-"} {row?.middle_name || ""}{" "}
                      {row?.last_name || ""}
                    </b>{" "}
                    {row?.country_code} {row?.phone_no || "-"}
                    <br />
                    {row?.email || "-"}
                  </p>
                </div>
              );
            },
          },
        ]),
    {
      flex: 1,
      minWidth: 150,
      field: "visa_type",
      headerName: "Visa Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{VISA_TYPE_NAMES[row?.visa_type] || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "country",
      headerName: "Country",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.visa_for_country || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "companyName",
      headerName: "B2B Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.work_company_name || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "paymentPlan",
      headerName: "Payment Plan",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.payment_plan?.plan_name || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "totalPrice",
      headerName: "Total Price",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {PriceFormatter(row?.payment_plan?.total_price?.toString()) ||
                "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "amountPaid",
      headerName: "Paid Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p> {PriceFormatter(row?.paid_amount?.toString()) || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "amountPending",
      headerName: "Pending Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p> {PriceFormatter(row?.pending_amount?.toString()) || "-"}</p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "homeLocation",
      headerName: "Home Location",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.home_country || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "approvalStatus",
      headerName: "Approval Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Chip
            label={
              row?.is_rejected
                ? "Rejected"
                : row?.is_verified
                  ? "Approved"
                  : "Pending"
            }
            color={
              row?.is_verified
                ? "#4CAF50"
                : row?.is_rejected
                  ? "#D32F2F"
                  : "#FB8C00"
            }
            backgroundColor={
              row?.is_verified
                ? "#E8F5E9"
                : row?.is_rejected
                  ? "#FFEBEE"
                  : "#FFF3E0"
            }
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "Application Status",
      headerName: "Application Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const currentStatus = Number(applicationStatuses[row.id]) || 0; // Get the current status as a number
        const nextStatus = currentStatus + 1; // Define the next possible status
        return (
          <>
            {!row?.is_verified ? (
              <div className="user_block">
                <p> Not Applicable</p>
              </div>
            ) : (
              <Select
                fullWidth
                labelId="Application Status"
                id={`applicationStatuses-${row.id}`}
                value={applicationStatuses[row.id] || "default"}
                onChange={handleApplicationStatus(row)}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                {applicationStatusData?.map((item) => {
                  return (
                    <MenuItem
                      value={item?.id}
                      key={item?.id}
                      disabled={
                        item?.id <= currentStatus || item?.id > nextStatus
                      }
                      className="menu_disable"
                    >
                      {item?.label}
                    </MenuItem>
                  );
                })}
              </Select>
            )}
          </>
        );
      },
    },

    {
      flex: 0.2,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <>
                    {" "}
                    {selectedRow?.is_rejected ||
                    selectedRow?.is_verified ? null : (
                      <MenuItem
                        onClick={() => {
                          if (selectedId) {
                            setAnchorEl1(null);
                            setOpenApprovalModal(true);
                          }
                        }}
                      >
                        Approval
                      </MenuItem>
                    )}
                  </>
                ) : null}
                <MenuItem
                  onClick={() =>
                    navigate(
                      `/manage-applications/detail/${selectedRow?.visa_type === 1 ? VISA_TYPES_SLUGS.TOURIST_VISA : selectedRow?.visa_type === 2 ? VISA_TYPES_SLUGS.STUDY_VISA : selectedRow?.visa_type === 3 ? VISA_TYPES_SLUGS.WORK_VISA : VISA_TYPES_SLUGS.BUSINESS_VISA}/${selectedId}`
                    )
                  }
                >
                  View
                </MenuItem>
                {/* <MenuItem onClick={handleClose1}>Edit</MenuItem> */}
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_be_delete ? (
                  <MenuItem
                    onClick={() => {
                      setAnchorEl1(null);
                      setOpen(true);
                    }}
                  >
                    Delete
                  </MenuItem>
                ) : null}
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </div>
        </Box>
        <ConfirmationModal
          text={"Are you sure to delete this application?"}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={handleDeleteApplication}
        />
        <ApplicationApprovalModal
          openModal={openApprovalModal}
          setOpenModal={setOpenApprovalModal}
          handleSubmit={handleApproveReject}
          applicationStatus={applicationStatus}
          handleApprovalStatus={handleApprovalStatus}
          paymentPlan={paymentPlan}
          handlePaymentPlan={handlePaymentPlan}
          paymentPlansList={paymentPlansList}
          setApplicationStatus={setApplicationStatus}
          setPaymentPlan={setPaymentPlan}
          setRejectionReson={setRejectionReson}
          rejectionReason={rejectionReason}
        />
      </div>
    </>
  );
};
